/**
 * ═══════════════════════════════════════════════════════════════
 * NOVA PRO - CART DRAWER MANAGER - VERSION FINALE OPTIMISÉE
 * Gestion centralisée des cart drawers
 * FIX: Chargement différé pour ne pas bloquer Shopify Analytics
 * ═══════════════════════════════════════════════════════════════
 */

// Attendre que le DOM soit complètement chargé
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCartDrawerManager);
} else {
  // DOM déjà chargé (cas où le script arrive après DOMContentLoaded)
  initCartDrawerManager();
}

function initCartDrawerManager() {
  console.log('✅ Cart Drawer Manager - Initialisation');

  /**
   * FERMER TOUS LES CART DRAWERS SAUF CELUI QU'ON VEUT OUVRIR
   * @param {string} exceptStyle - Le style de cart à NE PAS fermer
   */
  window.closeAllCartDrawers = function(exceptStyle) {
    console.log('🔒 Fermeture drawers (sauf ' + (exceptStyle || 'tous') + ')');
    
    // Fermer Bold Cart (sauf si c'est celui qu'on veut ouvrir)
    if (exceptStyle !== 'bold') {
      var boldDrawer = document.getElementById('boldCartDrawer');
      var boldOverlay = document.getElementById('boldCartOverlay');
      if (boldDrawer && boldDrawer.classList.contains('active')) {
        boldDrawer.classList.remove('active');
      }
      if (boldOverlay && boldOverlay.classList.contains('active')) {
        boldOverlay.classList.remove('active');
      }
    }
    
    // Fermer Classic Cart (sauf si c'est celui qu'on veut ouvrir)
    if (exceptStyle !== 'classic') {
      var classicDrawer = document.getElementById('finalCartDrawer');
      var classicOverlay = document.getElementById('finalCartOverlay');
      if (classicDrawer && classicDrawer.classList.contains('active')) {
        classicDrawer.classList.remove('active');
      }
      if (classicOverlay && classicOverlay.classList.contains('active')) {
        classicOverlay.classList.remove('active');
      }
    }
    
    // Fermer Elegant Cart (sauf si c'est celui qu'on veut ouvrir)
    if (exceptStyle !== 'elegant') {
      var elegantDrawer = document.getElementById('elegantCartDrawer');
      var elegantOverlay = document.getElementById('elegantCartOverlay');
      if (elegantDrawer && elegantDrawer.classList.contains('active')) {
        elegantDrawer.classList.remove('active');
      }
      if (elegantOverlay && elegantOverlay.classList.contains('active')) {
        elegantOverlay.classList.remove('active');
      }
    }
    
    // Fermer Luxury Cart (sauf si c'est celui qu'on veut ouvrir)
    if (exceptStyle !== 'luxury') {
      var luxuryDrawer = document.getElementById('luxuryCartDrawer');
      var luxuryOverlay = document.getElementById('luxuryCartOverlay');
      if (luxuryDrawer && luxuryDrawer.classList.contains('active')) {
        luxuryDrawer.classList.remove('active');
      }
      if (luxuryOverlay && luxuryOverlay.classList.contains('active')) {
        luxuryOverlay.classList.remove('active');
      }
    }
    
    // Reset body scroll seulement si on ferme tout
    if (!exceptStyle) {
      document.body.style.overflow = '';
    }
  };

  /**
   * OUVRIR LE BON CART DRAWER
   * @param {string} cartStyle - Le style de cart drawer à ouvrir
   */
  window.openCorrectCartDrawer = function(cartStyle) {
    console.log('🎯 Ouverture cart drawer:', cartStyle);
    
    // Fermer tous les drawers SAUF celui qu'on veut ouvrir
    closeAllCartDrawers(cartStyle);
    
    // Petit délai pour éviter les conflits d'animation
    setTimeout(function() {
      
      // Ouvrir le drawer correspondant
      if (cartStyle === 'bold') {
        if (typeof openBoldCart === 'function') {
          openBoldCart();
        } else {
          console.error('❌ openBoldCart non disponible');
        }
      } 
      
      else if (cartStyle === 'classic') {
        if (typeof openFinalCart === 'function') {
          openFinalCart();
        } else {
          console.error('❌ openFinalCart non disponible');
        }
      } 
      
      else if (cartStyle === 'elegant') {
        if (typeof openElegantCart === 'function') {
          openElegantCart();
        } else {
          console.error('❌ openElegantCart non disponible');
        }
      } 
      
      else if (cartStyle === 'luxury') {
        if (typeof openLuxuryCart === 'function') {
          openLuxuryCart();
        } else {
          console.error('❌ openLuxuryCart non disponible');
        }
      } 
      
      else {
        console.warn('⚠️ Style inconnu:', cartStyle);
        
        // Fallback: ouvrir le premier drawer disponible
        if (typeof openBoldCart === 'function') {
          openBoldCart();
        } else if (typeof openFinalCart === 'function') {
          openFinalCart();
        } else if (typeof openElegantCart === 'function') {
          openElegantCart();
        } else if (typeof openLuxuryCart === 'function') {
          openLuxuryCart();
        } else {
          console.error('❌ Aucun cart drawer disponible');
        }
      }
      
    }, 100);
  };

  console.log('✅ Cart Drawer Manager - Prêt');
  }